import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { consentRequests } from '../requests/consents.requests';
import { createApiThunk } from '../utils/apiThunk';

import {
  ConsentLinkDto,
  TermGroupDto,
} from '@act/shared/data-transfer-objects';
import { resetRedux } from '../actions/sharedActions';

// DEPRECATED SLICE - legacy slice

// THUNKS/ACTIONS ==============================================================
export const updateConsent = createApiThunk(consentRequests.updateConsent);
export const createConsentLink = createApiThunk(
  consentRequests.createConsentLink
);

// INITIAL STATE ===============================================================
export interface ConsentsState {
  status: 'failed' | 'initial' | 'loading' | 'success';
  consentGroups: TermGroupDto[];
  consentLink: string;
}

const initialState: ConsentsState = {
  status: 'initial',
  consentGroups: null,
  consentLink: null,
};

// SLICE =======================================================================
export const consentsSlice = createSlice({
  name: 'consents',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(resetRedux, state => {
      state = { ...initialState };
      return state;
    });
    builder
      .addCase(updateConsent.pending, state => {
        state.status = 'loading';
      })
      .addCase(updateConsent.fulfilled, state => {
        state.status = 'success';
      })
      .addCase(updateConsent.rejected, state => {
        state.status = 'failed';
      });
    builder
      .addCase(createConsentLink.pending, state => {
        state.status = 'loading';
        state.consentLink = null;
      })
      .addCase(
        createConsentLink.fulfilled,
        (state, action: PayloadAction<ConsentLinkDto>) => {
          state.status = 'success';
          state.consentLink = action.payload.url;
        }
      )
      .addCase(createConsentLink.rejected, state => {
        state.status = 'failed';
      });
  },
});

// REDUCER =====================================================================
export const consentsReducer = consentsSlice.reducer;

// SELECTORS ===================================================================
// EXPORT HELPER ===============================================================
// EFFECTS =====================================================================
// WEBSOCKET ACTIONS ===========================================================
